// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { thaiChain as _thaiChain } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the thaiChain chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 7
 * Chain Name: ThaiChain
 * Default Block Explorer: https://exp.thaichain.org
 * Default RPC URL: https://rpc.thaichain.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { thaiChain } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: thaiChain,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const thaiChain = createCommon({
	..._thaiChain,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
